import {
  SendMessageRequest,
  SendMessageResponse,
  BulkMessageRequest,
  ChannelType,
  ChoicesResponse,
  RecipientList,
  RecipientType,
  AttachTemplate,
} from "./types";
import { ApiEndpoints } from "@shared/api/api-endpoints";
import { communicationApiClient } from "@shared/api/clients/apiClientFactory";

// Add your messaging-specific API calls here
export const messagingApi = {
  // Send direct message
  sendMessage: async (
    messageData: SendMessageRequest
  ): Promise<SendMessageResponse> => {
    const url = ApiEndpoints.createUrl("communication", `direct-message`);
    const response = await communicationApiClient.post(url, messageData);
    return response.data;
  },

  // New bulk messaging APIs
  sendBulkMessage: async (
    messageData: BulkMessageRequest
  ): Promise<SendMessageResponse> => {
    const url = ApiEndpoints.createUrl("communication", `bulk-notification`);
    const response = await communicationApiClient.post(url, messageData);
    return response.data;
  },

  getRecipientTypes: async (): Promise<ChoicesResponse<RecipientType>> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "communication",
      `choices/recipient_type`,
      (query) => {
        query.push("isDropdown", "true");
      }
    );
    const response = await communicationApiClient.get(url);
    return response.data.result;
  },

  getChannelTypes: async (): Promise<ChoicesResponse<ChannelType>> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "communication",
      `choices/channel_type`,
      (query) => {
        query.push("isDropdown", "true");
      }
    );
    const response = await communicationApiClient.get(url);
    return response.data.result;
  },

  getRecipientLists: async (
    utilityId: string,
    recipientType: string
  ): Promise<ChoicesResponse<RecipientList>> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "communication",
      `get-lists`,
      (query) => {
        query.push("remote_utility_id", utilityId.toString());
        query.push("recipient_type", recipientType);
        query.push("isDropdown", "true");
      }
    );
    const response = await communicationApiClient.get(url);
    return response.data.result;
  },
  getTemplates: async (
    utilityId: string,
    channelType: string
  ): Promise<AttachTemplate[]> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "communication",
      `get-templates`,
      (query) => {
        query.push("remote_utility_id", utilityId.toString());
        query.push("channel_type", channelType);
      }
    );
    const response = await communicationApiClient.get(url);
    return response.data.result;
  },
};
